import QuantityInput from "components/QuantityInput/QuantityInput";

export default QuantityInput;